export default "__VITE_ASSET__e20bdce4__"